import Color from 'color';
import store from '@/store';
import { PALETTE_COLOURS } from '@/store/types/getters';
import { COLOURS } from '@/store/types/namespaces';

// TODO: to config.
const minOpacity = 0.10;
const maxOpacity = 1.00;

export function getOpacity(op, max) {
  if (!op || !max) {
    return minOpacity;
  }

  const value = op / max;
  const opacityRange = maxOpacity - minOpacity;
  const opacity = minOpacity + (value * opacityRange);
  return opacity.toFixed(2);
}

export function withOpacity(colour, opacity) {
  const ret = Color(colour).alpha(opacity);
  return ret.string();
}

export function getColourInRange(args) {
  const { value, minimumValue, maximumValue } = args;
  const { startColour, endColour } = args;

  if (value === undefined || minimumValue === undefined || maximumValue === undefined) {
    return null;
  }

  // Bypass the mixing
  if (value === minimumValue) {
    return startColour;
  } if (value === maximumValue) {
    return endColour;
  }

  const scale = (value - minimumValue) / (maximumValue - minimumValue);
  return Color(startColour).mix(Color(endColour), scale).string();
}

export function getHslColourInRange(args) {
  const SATURATION = 75;
  const LIGHTNESS = 50;
  const {
    value,
    minimumValue,
    maximumValue,
    startHue = 0,
    endHue = 240,
  } = args;

  if (minimumValue === undefined || maximumValue === undefined) {
    return 'hsl(0, 0%, 0%)';
  }

  const scale = (value - minimumValue) / (maximumValue - minimumValue);
  const hueRange = endHue - startHue;
  const hue = Math.ceil(startHue + (scale * hueRange));

  return `hsl(${hue}, ${SATURATION}%, ${LIGHTNESS}%)`;
}

export function getStringHashColour(string, colours) {
  const hashString = function hashString(str) {
    if (str === undefined || str === null) {
      return false;
    }

    /* eslint-disable no-bitwise */
    return `${str}`.split('').reduce((strA, strB) => {
      const a = ((strA << 5) - strA) + strB.charCodeAt(0);
      return a & a;
    }, 0);
    /* eslint-enable no-bitwise */
  };

  const hashedString = hashString(string);
  const colourIndex = Math.abs(hashedString % colours.length);

  return colours[colourIndex];
}

export function getBoundaryColour(
  value,
  boundarySettings,
  reverse,
  relevance,
  returnAsName,
  palette,
) {
  const boundaries = boundarySettings || { middle: 50, top: 80 };

  let opacity = relevance;
  if (opacity === undefined || opacity === null) {
    opacity = 1;
  }

  const getReturnValue = (type) => {
    if (returnAsName === true) {
      return type;
    }
    return withOpacity(palette[type], opacity);
  };

  if (reverse) {
    // Check value against boundaries
    if (value < boundaries.middle) {
      return getReturnValue('error');
    } if (value >= boundaries.middle && value < boundaries.top) {
      return getReturnValue('warning');
    }
    return getReturnValue('success');
  }

  // Reversed boundaries (above top boundaries is error)
  if (value >= boundaries.top) {
    return getReturnValue('error');
  } if (value < boundaries.top && value >= boundaries.middle) {
    return getReturnValue('warning');
  }
  return getReturnValue('success');
}

export function getBoundaryColourByLevel(level, relevance = 1) {
  const palette = store.getters[`${COLOURS}/${PALETTE_COLOURS}`];
  return Color(palette[level]).alpha(getOpacity(relevance, 1)).string();
}

export function getRagColourByEnum(rag) {
  const palette = store.getters[`${COLOURS}/${PALETTE_COLOURS}`];
  const colourMap = {
    0: palette.success,
    GREEN: palette.success,
    1: palette.warning,
    AMBER: palette.warning,
    3: palette.error,
    RED: palette.error,
  };
  return colourMap[rag] || null;
}

export function getChartColourByIndex(index) {
  const palette = store.getters[`${COLOURS}/${PALETTE_COLOURS}`].chart;
  return palette[index];
}
